export default {
  en: {
    agentList: 'Agent List',
    newAgent: 'New Agent',
    keyword: 'Keyword',
    agent: 'Agent',
    agentName: 'Name',
    type: 'Type',
    market: 'Market',
    internalNote: 'Internal Note',
    status: 'Status',
    action: 'Action',
    all: 'All',
    reset: 'Reset'
  },
  th: {
    agentList: 'รายชื่อตัวแทน',
    newAgent: 'สร้างตัวแทน',
    keyword: 'คำที่ต้องการค้นหา',
    agent: 'ตัวแทน',
    type: 'ประเภท',
    agentName: 'ชื่อตัวแทน',
    market: 'ตลาด',
    internalNote: 'โน๊ตภายใน',
    status: 'สถานะ',
    action: 'Action',
    all: 'ทั้งหมด',
    reset: 'ล้างค่า'
  }
}
